import { sortBreakpoints } from './sortBreakpoints';
export function findLargestMatchingBreakpoint(breakpoints, matchedBreakpoints, defaultBreakpoint) {
    var sortedBreakpoints = sortBreakpoints(breakpoints);
    // flag matching breakpoints
    for (var _i = 0, sortedBreakpoints_1 = sortedBreakpoints; _i < sortedBreakpoints_1.length; _i++) {
        var breakpoint = sortedBreakpoints_1[_i];
        if (matchedBreakpoints[breakpoint.name]) {
            return breakpoint.name;
        }
    }
    return defaultBreakpoint;
}
//# sourceMappingURL=findLargestMatchingBreakpoint.js.map